import React from 'react';
import $ from 'jquery';
import {UserDisplay} from '../user/userdisplay.js';
import HighlightModal from '../containers/highlightmodal.js';
import LocationUtil from '../../utils/locationutil.js';

class SideBarLink extends React.Component {

	render() {
		var additionalClass = (this.props.selected) ? ' Selected ' + this.props.moreClass : (this.props.subSelected) ? ' SubSelected ' + this.props.moreClass : ' ' + this.props.moreClass;
		return (
			<div className={"Link" + additionalClass}>
				<a href={this.props.link}>
					{this.props.label}
				</a>
			</div>
		);
	}
}

class SideBar extends React.Component {

	constructor(props) {
		super(props);

		this.createLinks = this.createLinks.bind(this);
		this.accessLevels = this.accessLevels.bind(this);

		this.state = { accessLevelShow : false };
	}

	createLinks(locations) {

		//The location we are at will be used to highlight and disable the link of the page we're on per design. 
		var links = [];
		var selectedLocation = {};

		for(var loc in locations) {
			if(this.props.location.indexOf(locations[loc].label) > -1) {
				if(this.props.location === locations[loc].label) selectedLocation = locations[loc];
				else if (Object.keys(selectedLocation).length === 0) selectedLocation = locations[loc];
			}
		}

		const supers = LocationUtil.getSupers(selectedLocation);
		////console.log(supers);

		const recSponsorIds = ['1', 'aa34fc30-4223-47e7-96fd-3b3ddf3735c1', //HTMA
		'8', '710a2eab-de21-4006-31a3-16daac3dd821',  //FCB
		'5', '9b4594bc-80d7-4e7c-b345-dd145968cfd8',  //WCCU
		'6', '843e1d42-a642-4e47-924d-1fd4d6942558',  //TCU
		'7', '218f13ac-aec7-4771-9e84-260a673bd899', //Milford
		'2', '7b34fc32-1223-47e7-96fd-3b3ddf3735c1', //ChoiceOne,
		'4', '3e010225-9b03-4122-bb85-268442034540', //Bank Michigan
		'3', '4ebe7405-cb40-4769-94a9-2b839dabc15e', //FABT
		'9', 'd1e6c140-ca37-4521-b38f-131a37e99a58', //4Front
		'10', '4c6c41c0-71e4-41da-8b1d-a19ef1509152', //First Bank
		'13', '52a3c421-4ad1-4720-6112-4fafb4c2d0e7', //Chelsea State Bank
		'14', 'e8be0859-71ab-4948-86a4-29b42aea82f2' //Timberland
		];

		for(var lKey in locations) {
			//Mark as selected if this is a sub sub or the actual place we at
			var selected = (locations[lKey].label === selectedLocation.label || (supers.length && supers[0].indexOf(locations[lKey].name) > -1 && selectedLocation.link.length === 0)) ? true : false;
			//If a super is selected we gotta heighleght it
			var subSelected = (supers.indexOf(locations[lKey].name) > -1) ? true : false;
			
			if( (locations[lKey].sub.length && 
				selectedLocation.name !== locations[lKey].sub && 
				selectedLocation.sub !== locations[lKey].sub &&
				supers.indexOf(locations[lKey].name) === -1 &&
				supers.indexOf(locations[lKey].sub) === -1) 
				|| locations[lKey].link.length === 0) continue;
			
			if( window.app.apiurl.indexOf('phobos.plinqit.com') === -1 && locations[lKey].name === 'Recommendations' 
				&& recSponsorIds.includes(window._fiSponsor.sponsors[0].id) === false ) continue;

			if(/* window._fiUser.ADMIN_CHECK === false && */locations[lKey].name === 'UserSupport') continue;
			links.push(
				<SideBarLink key={lKey} moreClass={locations[lKey].moreClass} link={locations[lKey].link} label={(locations[lKey].display) ? locations[lKey].display : locations[lKey].label} selected={selected} subSelected={subSelected} />
			);
		}

		return links;
	}

	accessLevels() {
		////console.log("SideBar.accessLevels");
		this.setState({ accessLevelShow : (this.state.accessLevelShow) ? false : 1});
	}

	render() {
		const allLocations = this.props.locations;
		const comp = this;

		var modalShow = false,
	        modalHeader = '',
	        modalPrompt = '',
	        //modalCancel = false,
	        //modalCancelCB = function () {},
	        modalAffirmative = 'Ok',
	        modalOnClick = function() {
	        	comp.setState({accessLevelShow : false});
	        };


	    switch(this.state.accessLevelShow) {
	      case 1:
	      	const modalBody = (
	      		<div className="Access-Levels">
	      			<div className="Prompt">{'This icon indicates which access level you have.'}</div>
	      			<div className="AL-Description">
	      				<div className="AL-Icon"><img src={ process.env.PUBLIC_URL + "images/accesslevelgreen.png"} alt='Admin Icon' /></div>
	      				<div className="AL-Desc-Header">Account Administrator</div>
	      				<div className="AL-Desc-Body">Has the ability to add new dashboard users and control their access level, edit app settings, request new zipcodes, view all charts.</div>
	      			</div>
	      			<div className="AL-Description">
	      				<div className="AL-Icon"><img src={ process.env.PUBLIC_URL + "images/accesslevelblue.png"} alt='Marketing Icon' /></div>
	      				<div className="AL-Desc-Header">Marketing Manager</div>
	      				<div className="AL-Desc-Body">Cannot add or remove users. Other access as assigned by the account admin.</div>
	      			</div>
	      			<div className="AL-Description">
	      				<div className="AL-Icon"><img src={ process.env.PUBLIC_URL + "images/accesslevelorange.png"} alt='Analyst Icon' /></div>
	      				<div className="AL-Desc-Header">Business Analyst</div>
	      				<div className="AL-Desc-Body">Cannot add or remove users, view only charts, insights and user reports as assigned by the Account Admin.</div>
	      			</div>
	      		</div>
	      	);
	        modalPrompt = (
	          <div className="ModalBody">
	          	{modalBody}
	          </div>
	        );
	        modalShow = true;
	        modalHeader = 'Access Level';
	        break;
	      default:
	        break;
	    }

		return (

					<div className="App-SideBarContainer">
						<div className="App-SideBarHeader">Welcome</div>
						<UserDisplay name={window._fiUser.firstname + ' ' + window._fiUser.lastname} accesslevel={window._fiUser.role} onALClick={this.accessLevels} />

						{this.createLinks(allLocations)}

						<HighlightModal key="TheModal" size={{width: '60vmin', height : '70vmin'}} highlight={$('.App-UserDisplay')} visible={modalShow} header={modalHeader} content={modalPrompt} affirmativeLabel={modalAffirmative} onClick={modalOnClick} />
					</div>
				);
	}
}

export {SideBarLink, SideBar};